export default __webpack_public_path__ + "static/media/add-to-playlist-orange.23088a81.svg";